<template>
    <div class="transfer-box">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">充提系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>站内提现审批</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="condition-box">
            <el-card class="page-content" shadow="never">
                <el-tabs v-model="activeStatus" @tab-click="handleTabClick($event)">
                    <el-tab-pane v-for="item in statusList" :label="item.label" :key="item.value"
                                 :name="item.value"></el-tab-pane>
                </el-tabs>

                <div class="condition-select">
                    <el-autocomplete class="inline-input" v-model="queryParams.coinType"
                                     :fetch-suggestions="querySearch" placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix" @click="cleanSearchCoin"
                           style="cursor:pointer;"></i>
                    </el-autocomplete>
                    <el-date-picker v-model="dateArr" type="datetimerange" range-separator="至"
                                    start-placeholder="下单开始时间"
                                    end-placeholder="下单结束时间" value-format="timestamp"></el-date-picker>
                    <el-select v-model="queryParams.type" placeholder="请选择">
                        <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input placeholder="请输入内容" clearable v-model="queryParams.typeValue" style="width: 350px">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="handleSearch">搜索</el-button>
                    <el-checkbox v-model="queryParams.showTag" @change="handleSearch()" label="展示标签用户" style="margin-left: 10px"></el-checkbox>
                  <el-button @click="batchAuditPass" type="primary" v-if="queryParams.status === 'INIT' || queryParams.status === 'RE_CHECK'">一键审核通过</el-button>
                </div>

                <div class="table-list">
                    <el-table :data="dataList" ref="multipleTable" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55" v-if="queryParams.status === 'INIT' || queryParams.status === 'RE_CHECK'"></el-table-column>
                        <el-table-column prop="id" label="订单编号"></el-table-column>
                        <el-table-column label="风控提示">
                            <template  slot-scope="scope">
                                <div v-if="scope.row.riskFlag">
                                    <span style="color:red" v-if="scope.row.riskFlag.blockAccountFlag == 1">账户冻结&nbsp;&nbsp;</span>
                                    <span style="color:red" v-if="scope.row.riskFlag.forbidOutGoldFlag == 1">禁止提现</span>
                                    <span v-if='scope.row.riskFlag.riskFlag ==false'>--</span>
                                </div>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="下单用户ID">
                            <template slot-scope="scope">
                                <a class="account-link" @click="getUserDetail(scope.row.fromUser)">{{scope.row.fromUser}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="toUserUid" label="提现用户UID"></el-table-column>
                        <el-table-column prop="toUser" label="提现账户ID"></el-table-column>
                        <el-table-column label="提现账户">
                            <template slot-scope="scope">
                                <span>{{scope.row.toUserTel?scope.row.toUserTel:scope.row.toUserEmail}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="标签" v-if="queryParams.showTag">
                            <template slot-scope="scope"><span style="color: red">{{scope.row.tags}}</span></template>
                        </el-table-column>
                        <el-table-column prop="txCoin" label="币种"></el-table-column>
                        <el-table-column prop="txAmount" label="提币数量"></el-table-column>
                        <el-table-column prop="txFee" label="手续费"></el-table-column>
                        <el-table-column prop="txStatusDesc" label="订单状态"></el-table-column>
                        <el-table-column min-width="60" label="申请时间">
                            <template slot-scope="scope">
                                {{scope.row.createTime | moment}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="60" label="审核时间">
                            <template slot-scope="scope">
                                {{scope.row.checkTime | moment}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="60" label="提币时间">
                            <template slot-scope="scope">
                                {{scope.row.transferTime | moment}}
                            </template>
                        </el-table-column>
                        <el-table-column min-width="60" label="取消时间">
                            <template slot-scope="scope">
                                {{scope.row.cancelTime | moment}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="150">
                            <template slot-scope="scope">
                                <el-button @click="openOrderReviewDialog(scope.row.id)" type="warning"
                                           v-if="scope.row.txInnerStatus=='INIT' || scope.row.txInnerStatus=='RE_CHECK'">
                                    审核订单
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination style="margin-top: 30px"
                                   @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="queryParams.page"
                                   :page-sizes="[10, 20, 50, 100]"
                                   :page-size="queryParams.size"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="total">
                    </el-pagination>
                </div>
            </el-card>
        </div>

        <el-dialog title="订单审核" :visible.sync="orderReviewDialogVisible" width="30%" @close="clearData">
            <el-form>
                <el-form-item label="状态" label-width="100px">
                    <el-select v-model="reviewParams.status" placeholder="请选择">
                        <el-option label="通过" value="PASS"></el-option>
                        <el-option label="不通过" value="REFUSE"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="原因(中文)" label-width="100px" v-if="reviewParams.status == 'REFUSE'">
                    <el-input type="textarea" maxlength="100" show-word-limit="true" v-model="reviewData.zh"></el-input>
                </el-form-item>
                <el-form-item label="原因(英文)" label-width="100px" v-if="reviewParams.status == 'REFUSE'">
                    <el-input type="textarea" maxlength="100" show-word-limit="true" v-model="reviewData.en"></el-input>
                    <span style="color: red">审核不通过，订单将会直接取消</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearData">取 消</el-button>
                <el-button type="primary" @click="orderReview">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="showUserDialogVisible" title="提币记录" width="1200px">
            <div class="action">
                <div class="back">
                    <span class="invitestyle">邀请返佣金额总计：{{raketotal}} USDT</span>
                    <span class="invitestyle">合约返佣：{{contract}} USDT</span>
                    <span class="invitestyle">现货手续费返佣+活期宝返佣：{{service}} USDT</span>
                </div>
                <el-checkbox v-model="hideZero">隐藏余额为0的币种</el-checkbox>
            </div>
            <el-table :data="userWallet | filterList(hideZero)">
                <el-table-column prop="coinType" label="币种">
                </el-table-column>
                <el-table-column prop="currentInterest" label="活期利息">
                </el-table-column>
                <el-table-column label="C2C买入/卖出">
                    <template slot-scope="scope">{{scope.row.c2cBuy}}/{{scope.row.c2cSell}}</template>
                </el-table-column>
                <el-table-column label="OTC买入/卖出">
                    <template slot-scope="scope">{{scope.row.otcBuy}}/{{scope.row.otcSell}}</template>
                </el-table-column>
                <el-table-column label="充值/提现">
                    <template slot-scope="scope">{{scope.row.deposit}}/{{scope.row.withdrawal}}</template>
                </el-table-column>
                <el-table-column label="(站内)充值/提现">
                    <template slot-scope="scope">{{scope.row.internalDeposit}}/{{scope.row.internalWithdrawal}}</template>
                </el-table-column>
                <el-table-column label="合约买入/卖出">
                    <template slot-scope="scope">{{scope.row.contractBuy}}/{{scope.row.contractSell}}</template>
                </el-table-column>
                <el-table-column label="WALLET可用/冻结">
                    <template slot-scope="scope">{{scope.row.coinAmount}}/{{scope.row.coinFroze}}</template>
                </el-table-column>
                <el-table-column label="OTC可用/冻结">
                    <template slot-scope="scope">{{scope.row.otcCoinAmount}}/{{scope.row.otcCoinFroze}}</template>
                </el-table-column>
                <el-table-column label="超级合约可用/冻结">
                    <template slot-scope="scope">{{scope.row.generalAvailableAmount}}/{{scope.row.generalFrozeAmount}}</template>
                </el-table-column>
                <el-table-column label="超级合约盈亏" prop="generalProfit"/>
                <el-table-column label="合约可用/冻结">
                    <template slot-scope="scope">{{scope.row.contractAvailableAmount}}/{{scope.row.contractFrozeAmount}}</template>
                </el-table-column>
                 <el-table-column label="跟单可用/冻结">
                  <template slot-scope="scope">{{scope.row.followAvailableAmount}}/{{scope.row.followFrozeAmount}}</template>
              </el-table-column>
                <el-table-column prop="totalAmount" label="总量"/>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'TransferStation',
        data() {
            return {
                dataList: [],
                total: 0,
                dateArr: [],
                allCoins: [],
                userWallet: [],
                orderReviewDialogVisible: false,
                showUserDialogVisible: false,
                activeStatus: "ALL",
                queryParams: {
                    type: "0",
                    typeValue: "",
                    startTime: "",
                    endTime: "",
                    orderId: "",
                    uId: "",
                    userId: "",
                    coinType: "",
                    username: "",
                    status: "",
                    showTag: false,
                    page: 1,
                    size: 10,
                },
                reviewParams: {
                    id: "",
                    status: "PASS",
                    remark: ""
                },
                reviewData: {zh: "", en: ""},
                typeList: [
                    {label: '手机或邮箱', value: "0"},
                    {label: '提币订单编号', value: "1"},
                    {label: '邀请码', value: "2"},
                    {label: '用户ID', value: "3"},
                ],
                statusList: [
                    {label: '全部', value: 'ALL'},
                    {label: '初始化,等待审批', value: 'INIT'},
                    {label: '二次审核中', value: 'RE_CHECK'},
                    {label: '用户取消', value: 'CANCEL'},
                    {label: '核通过,待转账', value: 'PASS'},
                    {label: '转账中', value: 'EXECUTING_TRANSFER'},
                    {label: '转账失败', value: 'FAIL'},
                    {label: '审核不通过', value: 'REFUSE'},
                    {label: '转账成功', value: 'SUCCESS'},
                ],
                hideZero: true,
                contract:null,
                service:null,
                raketotal:null,
                multipleSelection: []
            };
        },
        filters: {
            filterList: (value, isHide) => {
                return value.filter(item => (isHide ? ((item.currentInterest !== 0) || (item.c2cBuy !== 0) || (item.c2cSell !== 0) || (item.deposit !== 0)
                    || (item.withdrawal !== 0) || (item.coinAmount !== 0) || (item.coinFroze !== 0) || (item.totalAmount !== 0))
                    || (item.internalDeposit !== 0) || (item.internalWithdrawal !== 0)
                    || (item.otcCoinAmount !== 0) || (item.otcCoinFroze !== 0) || (item.generalAvailableAmount !== 0) || (item.generalFrozeAmount !== 0)
                    || (item.contractAvailableAmount !== 0 || (item.contractFrozeAmount !== 0)) || item.generalProfit !== 0 : true));
            }
        },
        methods: {
            bulidParams() {
                this.queryParams.status = this.activeStatus == "ALL" ? "" : this.activeStatus;
                this.queryParams.startTime = this.dateArr == null ? null : this.dateArr[0];
                this.queryParams.endTime = this.dateArr == null ? null : this.dateArr[1];
                if (this.queryParams.type == "0") {
                    this.queryParams.orderId = "";
                    this.queryParams.uId = "";
                    this.queryParams.userId = "";
                    this.queryParams.username = this.queryParams.typeValue;
                } else if (this.queryParams.type == "1") {
                    this.queryParams.username = "";
                    this.queryParams.uId = "";
                    this.queryParams.userId = "";
                    this.queryParams.orderId = this.queryParams.typeValue;
                } else if (this.queryParams.type == "2") {
                    this.queryParams.username = "";
                    this.queryParams.orderId = "";
                    this.queryParams.userId = "";
                    this.queryParams.uId = this.queryParams.typeValue;
                } else if (this.queryParams.type == "3") {
                    this.queryParams.username = "";
                    this.queryParams.orderId = "";
                    this.queryParams.uId = "";
                    this.queryParams.userId = this.queryParams.typeValue;
                }
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.allCoins;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.allCoins;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            getAllCoins() {
                api.getAllCoins().then(({data}) => {
                    this.allCoins = data;
                });
            },
            getWithdrawInternalList() {
                this.bulidParams();
                api.getWithdrawInternalList(this.queryParams).then(({data}) => {
                    let ary = [];
                    let riskobj = {}
                    data.list.map(item=>{
                        ary.push(item.fromUser)
                    })
                    // this.dataList = data.list;
                    // this.total = data.totalCount;
                  this.dataList = data.list;
                  this.total = data.totalCount;
                    // api.userRiskFlagList([...ary]).then((obj)=>{
                    //     riskobj = obj.data
                    //     data.list.map(item=>{
                    //         Object.keys(riskobj).forEach((key)=>{
                    //             if(item.fromUser == key){
                    //                 item.riskFlag = riskobj[key]
                    //             }
                    //         })
                    //     })
                    //     this.dataList = data.list;
                    //     this.total = data.totalCount;
                    // }).catch(err=>{
                    //     this.dataList = data.list;
                    //     this.total = data.totarlCount;
                    // })
                });
            },
            getUserDetail(userId) {
                this.userWallet = [];

                api.getRebateAmount({userId:userId}).then(({data}) => {
                    this.contract = data.hyRewards;
                    this.service = data.xhRewards;
                    this.raketotal = data.hyRewards + data.xhRewards;
                });
                api.findUserWithdrawalAndDepositRecord({userId:userId}).then(({data}) => {
                    this.userWallet = data;
                    this.showUserDialogVisible = true;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getWithdrawInternalList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getWithdrawInternalList();
            },
            handleTabClick(tab) {
                this.queryParams = {
                    type: "0",
                    typeValue: "",
                    startTime: "",
                    endTime: "",
                    orderId: "",
                    uId: "",
                    coinType: "",
                    username: "",
                    status: tab.name == "ALL" ? "" : tab,
                    showTag: false,
                    page: 1,
                    size: 10,
                };
                this.dateArr = [];
                this.getWithdrawInternalList();
            },
            handleSearch() {
                this.getWithdrawInternalList();
            },
            openOrderReviewDialog(data) {
                // this.reviewParams.id = data.id;
                this.reviewParams.id = data;
                // this.reviewParams.riskFlag = data.riskFlag;
                this.orderReviewDialogVisible = true;
            },
            orderReview() {
                if (this.reviewParams.id == null || this.reviewParams.id == "" || this.reviewParams.id <= 0) {
                    this.$message.error('订单ID不存在！');
                    return;
                }
                this.reviewParams.remark = "";
                if (this.reviewParams.status == 'REFUSE') {
                    this.reviewParams.remark = JSON.stringify(this.reviewData);
                    if (this.reviewData.zh == '' || this.reviewData.en == '') {
                        this.$message.error('请填写不通过原因！');
                        return
                    }
                }
                if(this.reviewParams.riskFlag == true){
                    this.$confirm('该用户处在风控状态，请确认后，再审批提现订单！', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.getTransfer(this.reviewParams)
                    }).catch(() => {
                        this.$message.info("已取消执行")
                    })
                }else{
                    this.getTransfer(this.reviewParams)
                }
            },
            getTransfer(data){
                api.transfer(data).then(({data}) => {
                    this.$message.success('操作成功！');
                    this.orderReviewDialogVisible = false;
                    this.getWithdrawInternalList();
                });
            },
            clearData() {
                this.orderReviewDialogVisible = false;
                this.reviewParams = {id: "", status: "PASS", remark: ""};
                this.reviewData = {zh: "", en: ""};
                this.hideZero = true;
            },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          batchAuditPass() {
            if (this.multipleSelection.length <= 0) {
              this.$message.info("请勾选需要审核的数据");
              return;
            }
            this.$confirm('确认进行批量审核吗', '提示', {
              type: 'warning'
            }).then(async () => {
              for (let i = 0; i < this.multipleSelection.length; i++) {
                let id = this.multipleSelection[i].id;
                if (id == null || id === "" || id <= 0) {
                  this.$message.error('订单ID不存在！');
                  return;
                }
                this.reviewParams = {id: this.multipleSelection[i].id, status: "PASS"}
                await api.transfer(this.reviewParams).then(({}) => {
                });
              }
              this.$message.success('操作成功！');
              this.getWithdrawInternalList();
            }).catch(() => {
            });
          }
        },
        created() {
            this.getAllCoins();
            this.getWithdrawInternalList();
        }
    };
</script>

<style lang="less" scoped>
    @import url('~styles/variables.less');
    .transfer-box {
        .condition-box {
            margin-top: 20px;
            .condition-select {
                margin-top: 10px;
            }
            .table-list {
                margin-top: 20px;
                .account-link,
                .network-link {
                    color: @color-primary;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .action{
        display: flex;
        justify-content: space-between;
        .back{
            // height: 50px;
            color: #409EFF;
            >span{
                display: block;
            }
        }
    }
</style>

